module.exports = __webpack_public_path__ + "static/img/goods_default_img.4c38da9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/goodsList/goods_default_img.jpg
// module id = wBRU
// module chunks = 103